var _rect, _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#3CC64A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32923 15.2293L5.85423 11.7543L4.6709 12.9293L9.32923 17.5876L19.3292 7.5876L18.1542 6.4126L9.32923 15.2293Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32923 15.2293L5.85423 11.7543L4.6709 12.9293L9.32923 17.5876L19.3292 7.5876L18.1542 6.4126L9.32923 15.2293Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.e96994c460c5ce0ee2613dc3e4869726.svg";
export { ForwardRef as ReactComponent };